<!-- Method, only when the Driver is Site -->
<div class="forecast-table-grid-select-container">
  <ng-select
    #dropdown
    class="forecast-table-grid-select"
    [searchable]="false"
    [clearable]="false"
    [appendTo]="'ag-grid-angular'"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [auxTooltip]="tooltip"
    [ngClass]="{ 'is-invalid': isInvalid }"
    [(ngModel)]="driverSettingId"
    (open)="onDropdownOpen()"
    (close)="onDropdownClose()"
    (ngModelChange)="onModelChange($event)"
  >
    @for (item of filteredSiteCurves; track item; let index = $index; let first = $first) {
      <ng-option [value]="item.value">
        {{ item.label }}
      </ng-option>
    }
    <ng-template ng-footer-tmp class="flex flex-col">
      <div class="items-wrapper grow">
        @for (item of filteredSiteCurves; track item; let first = $first; let last = $last) {
          <ng-option [value]="item.value">
            @if (item.showLine && !first) {
              <div class="mx-1 my-1 h-1 border-b border-aux-gray-darkest"></div>
            }
            <div
              class="option-font relative -mx-2 flex cursor-pointer select-none justify-between py-3 pl-3"
              [class.selected-item]="driverSettingId === item.value"
              [class.first-item]="first"
              [class.last-item]="last"
              [class.hover-item]="driverSettingId !== item.value"
              (click)="onModelChange(item.value); dropdown.close()"
            >
              <div class="flex-1">
                {{ item.label }}
              </div>
              @if (dropdownOpen && driverSettingId === item.value) {
                <aux-icon class="checkmark mr-2" name="Check" />
              }
            </div>
          </ng-option>
        }
      </div>
    </ng-template>
  </ng-select>
</div>
